import { Signal as SignalMini } from 'fxs-signals-mini';
import { Signal as SignalTable } from 'fxs-signals-table';
import { toDateUtc } from 'fxs-utils';

import { NumericSideType, StatusType, TradeActionType } from '../models/enums';
import { TradeMessagePush } from '../models/signalPushMessages';
import { Trade } from '../models/trades';
import { stringToNumericSideType } from '../utils/sideTypeUtils';

const getStatus = (
	closingTimeUtc: Date | undefined,
	pips: number
): StatusType => {
	if (!closingTimeUtc) return StatusType.Running;
	if (pips > 0) return StatusType.Win;
	return StatusType.Loss;
};
export const mapMiniFromApi = (source: Trade): SignalMini => ({
	positionMaintenanceId: source.positionMaintenanceId,
	asset: source.asset,
	entryPrice: source.entryPrice,
	profitPercent: source.profitPercent,
	stopLoss: source.stopLoss,
	takeProfit: source.takeProfit,
	openingTimeUtc: toDateUtc(source.openingTimeUtc),
	closingTimeUtc: source.closingTimeUtc
		? toDateUtc(source.closingTimeUtc)
		: undefined,
	sideType:
		typeof source.sideType === 'number'
			? source.sideType === 0
				? NumericSideType.Buy
				: NumericSideType.Sell
			: stringToNumericSideType(source.sideType as string),
	status: getStatus(source.closingTimeUtc, source.pips || 0),
	pips: source.pips
});
export const mapTableFromApi = (source: Trade): SignalTable => ({
	positionMaintenanceId: source.positionMaintenanceId,
	asset: source.asset,
	entryPrice: source.entryPrice,
	profitPercent: source.profitPercent,
	stopLoss: source.stopLoss,
	takeProfit: source.takeProfit,
	openingTimeUtc: toDateUtc(source.openingTimeUtc),
	closingTimeUtc: source.closingTimeUtc
		? toDateUtc(source.closingTimeUtc)
		: undefined,
	sideType:
		typeof source.sideType === 'number'
			? source.sideType === 0
				? NumericSideType.Buy
				: NumericSideType.Sell
			: stringToNumericSideType(source.sideType as string),
	status: getStatus(source.closingTimeUtc, source.pips || 0),
	isHighlighted: source.isHighlighted,
	limitType: source.limitType,
	limitsHaveChanged: false,
	exitPrice: source.exitPrice,
	pips: source.pips,
	riskRewardRatio: source.riskRewardRatio,
	riskReward: source.riskReward
});
export const mapFromPush = (source: TradeMessagePush): Trade => ({
	positionMaintenanceId: source.PositionMaintenanceId,
	asset: source.Asset,
	strategyFancyName: source.StrategyFancyName,
	strategyId: source.StrategyId,
	entryPrice: source.EntryPrice,
	profitPercent: source.ProfitPercent,
	stopLoss: source.StopLoss,
	takeProfit: source.TakeProfit,
	openingTimeUtc: toDateUtc(source.OpeningTimeUtc),
	closingTimeUtc: source.ClosingTimeUtc
		? toDateUtc(source.ClosingTimeUtc)
		: undefined,
	sideType: source.SideType,
	status: getStatus(source.ClosingTimeUtc, source.Pips || 0),
	isHighlighted: true,
	limitType: source.LimitType,
	limitsHaveChanged: source.ActionType === TradeActionType.Updated,
	exitPrice: source.ExitPrice,
	pips: source.Pips,
	riskRewardRatio: source.RiskRewardRatio,
	riskReward: source.RiskReward
});
